import { useTranslation } from 'next-i18next'
import * as yup from 'yup'
import { SignUpFormValues } from 'components/Auth/SignUpFormValues'

export const SignUpFormSchema = () => {
  const { t } = useTranslation('errors', { keyPrefix: 'validation' })

  return yup.object<SignUpFormValues>().shape({
    firstName: yup.string().required(t('required')),
    lastName: yup.string().required(t('required')),
    email: yup.string().email(t('email')).required(t('required')),
    password: yup
      .string()
      .required(t('required'))
      .min(8, t('min', { number: 8 }))
      .test('validPassword', t('validPassword'), (value) => {
        if (!value) {
          return false
        }
        const hasUpperCase = /[A-Z]/.test(value)
        const hasLowerCase = /[a-z]/.test(value)
        const hasNumber = /[0-9]/.test(value)

        return [hasLowerCase, hasUpperCase, hasNumber].every(Boolean)
      })
  })
}

export const SignUpAPISchema = yup.object<SignUpFormValues>().shape({
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  email: yup.string().email().required(),
  language: yup.string().required(),
  password: yup
    .string()
    .required()
    .min(8)
    .test('validPassword', (value) => {
      if (!value) {
        return false
      }
      const hasUpperCase = /[A-Z]/.test(value)
      const hasLowerCase = /[a-z]/.test(value)
      const hasNumber = /[0-9]/.test(value)

      return [hasLowerCase, hasUpperCase, hasNumber].every(Boolean)
    })
})
